import {
    paymentSchema,
    validateInvoicePaymentCreate as validatePaymentCreate,
} from "utilities/dist/invoice/validator";

export const validateInvoicePaymentCreate = payment =>
    validatePaymentCreate(payment, paymentSchema);

export const validateInvoicePaymentUpdate = validateInvoicePaymentCreate();
